var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.damages),function(damage){return _c('damage',{key:damage.id,attrs:{"damage":damage},on:{"delete-damage":_vm.deleteDamage,"update:damage":function($event){damage=$event}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }